import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id F9A7F6AA-7379-4215-A97A-0E2FCAF3A9ED
 * name tray
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tray.svg
 * tags
 */
export const TrayIcon = createSvgIcon(<><path d="M2 12H4V17H20V12H22V17A2 2 0 0 1 20 19H4A2 2 0 0 1 2 17Z" /></>, 'TrayIcon');
export default TrayIcon